import {useQuery} from '@tanstack/react-query';
import {usersApi} from '../api';
import {UserModel} from '../model';
import {useMemo} from 'react';

export const useUsersByIds = (userIds: string[]) => {
  const query = useQuery<UserModel[], Error>({
    queryKey: ['users', 'byIds', userIds.sort()],
    queryFn: () => usersApi.getUsersByIds(userIds),
    enabled: userIds.length > 0,
    staleTime: 5 * 60 * 1000,
  });

  const usersData = useMemo(() => {
    const data: Record<string, {displayName: string; avatarUrl: string | null}> = {};

    if (query.data) {
      query.data.forEach((user) => {
        data[user.id] = {
          displayName: user.displayName,
          avatarUrl: user.avatarUrl,
        };
      });
    }

    return data;
  }, [query.data]);

  return {
    usersData,
    isLoading: query.isLoading,
    error: query.error,
  };
};
